import { Card } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useTaskSlice } from '../../../../slice';
import {
  selectTaskListFilters,
  selectTaskListState,
} from '../../../../slice/selectors';
import { ITaskFilters } from '../../../../slice/types';
import TaskListFilters from '../../../../parts/TaskListFilters/TaskListFilters';

interface IProps {}

const TaskListFiltersCard: FC<IProps> = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const taskActions = useTaskSlice().actions;

  const filters = useSelector(selectTaskListFilters);
  const taskListState = useSelector(selectTaskListState);
  const setFilters = (filters: ITaskFilters) => {
    dispatch(taskActions.setTaskListFilters(filters));
  };

  const setCurrentPage = (page: number) => {
    dispatch(taskActions.setTaskListCurrentPage(page));
  };
  return (
    <Card title={t('Common.Filters', 'Filters')} bordered={false}>
      <TaskListFilters
        sort={taskListState.sort}
        filters={filters}
        setFilters={setFilters}
        setCurrentPage={setCurrentPage}
        currentPage={taskListState.currentPage}
      />
    </Card>
  );
};

export default TaskListFiltersCard;
